import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import {
  FC,
  MutableRefObject,
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import styled from 'styled-components'
import Question from 'components/Question'
import Header from 'components/Header'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import questions from '../../Assets/schweiz_quiz_fr'
import questionsDE from '../../Assets/schweiz_quiz_de'
import { device } from '../breakpoints'

import { Municipality } from '@ta-interaktiv/react-municipality-search'
import { firebaseContext } from 'components/firebaseDbRefContext'

import { child, off, onValue } from 'firebase/database'
import { unityPropsContext } from 'components/UnityPropsContext'
// import Overview from 'components/Overview'
function usePrevious<T>(value: T): MutableRefObject<T | undefined>['current'] {
  const ref = useRef<T>()
  useEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}
const MainComponent: FC<MicroFrontendProps> = ({
  properties,
  tenant,
  colorMode,
}): ReactElement => {
  const unityProps = useContext(unityPropsContext)
  const propertiesWithDefaults = { ...unityProps, ...properties }

  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const [selectedMunicipality, setSelectedMunicipality] =
    useState<Municipality>()
  const prevSelectedMunicipality = usePrevious(selectedMunicipality)
  const [allMunicipalities, setAllMunicipalities] = useState<Municipality[]>()
  const [nationalAverages, setNationalAverages] = useState<Guess>()
  const [municipalityAverages, setMunicipalityAverages] = useState<Guess>()
  const firebaseGlobals = useContext(firebaseContext)
  const setSelectedMuniFromLocalStorage = (
    allFetchedMunicipalities: Municipality[],
    selectedBfsIdFromLocalStorage: string | undefined
  ) => {
    if (selectedBfsIdFromLocalStorage) {
      setSelectedMunicipality(
        allFetchedMunicipalities?.find(
          (muni) => muni.GDENR == JSON.parse(selectedBfsIdFromLocalStorage)
        )
      )
      updateBfsIdInURL(String(JSON.parse(selectedBfsIdFromLocalStorage)))
    }
  }
  const getGuessesFromDB = async () => {
    // remove listeners
    try {
      if (prevSelectedMunicipality?.GDENR) {
        off(
          child(
            firebaseGlobals.municipalityAveragesRef,
            String(prevSelectedMunicipality.GDENR)
          )
        )
      } else {
        off(
          child(
            firebaseGlobals.municipalityAveragesRef,
            String(selectedMunicipality?.GDENR)
          )
        )
      }
    } catch (error) {
      console.error(error)
    }

    try {
      onValue(firebaseGlobals.nationalAveragesRef, (snapshotNational) => {
        console.log(snapshotNational.val())
        setNationalAverages(snapshotNational.val())
      })
      onValue(
        child(
          firebaseGlobals.municipalityAveragesRef,
          String(selectedMunicipality?.GDENR)
        ),
        (snapshotMunicipality) => {
          setMunicipalityAverages(snapshotMunicipality.val())
        }
      )
    } catch (error) {
      console.error(error)
    }
  }

  const updateBfsIdInURL = (bfsId: string) => {
    const url = new URL(String(window.location))
    url.searchParams.set(propertiesWithDefaults.bfsIdParamName, bfsId)
    window.history.pushState({}, '', url)
  }
  useEffect(() => {
    // get preselected Muni from URL
    const searchParams = new URL(String(window.location)).searchParams
    const muniParam = searchParams.get('gemeinde')
    const bfsIdFromUrl = muniParam && parseInt(muniParam)

    fetch(
      'https://interaktiv.tagesanzeiger.ch/static/gemeindesuche/20210101.json'
    ).then((res) =>
      res.json().then((parsed: Municipality[]) => {
        setAllMunicipalities(parsed)
        parsed.find((muni) => muni.GDENR === bfsIdFromUrl)
        const foundMuniFromURL = parsed.find(
          (muni) => muni.GDENR === bfsIdFromUrl
        )
        // set muni from URL and or if there is one use it from localstorage
        let selectedBfsIdFromLocalStorage
        try {
          selectedBfsIdFromLocalStorage = localStorage.getItem(
            'swissQuizSelectedBfsId'
          )
        } catch {
          selectedBfsIdFromLocalStorage = undefined
        }
        if (selectedBfsIdFromLocalStorage) {
          setSelectedMuniFromLocalStorage(parsed, selectedBfsIdFromLocalStorage)
        } else {
          foundMuniFromURL && setSelectedMunicipality(foundMuniFromURL)
        }
      })
    )
  }, [])

  useEffect(() => {
    getGuessesFromDB()
    if (tenant) {
      console.log('tenant', tenant.lang)
    }
  }, [selectedMunicipality])

  return (
    <AppContainer className={globalClasses.join(' ')}>
      <MainSection>
        <unityPropsContext.Provider value={propertiesWithDefaults}>
          <Header
            keywords={
              tenant.lang === 'de'
                ? 'Quiz zur Krönung von Charles'
                : 'Incollable sur Charles III'
            }
            title={
              tenant.lang === 'de' ? (
                <>13 Fragen zum verrückten Leben der britischen Royals</>
              ) : (
                <>Les chiffres fous de la monarchie britannique</>
              )
            }
            lead={
              tenant.lang === 'de'
                ? 'Kennen Sie sich besser mit der Monarchie aus als andere? Unser Schätzquiz zeigt, wie Sie im Vergleich mit anderen Teilnehmenden abschneiden.'
                : 'La grandeur britannique en un quiz. Saurez-vous l’estimer juste?'
            }
            tenant={tenant}
          />
          <firebaseContext.Provider value={firebaseGlobals}>
            <QuestionsContainer isActive>
              {/* <Title>{propertiesWithDefaults?.title}</Title> */}
              {Object.keys(
                tenant.lang === 'de'
                  ? questionsDE.onlyNational
                  : questions.onlyNational
              ).map((questionId) => {
                const question = tenant.lang === 'de' ? questionsDE : questions
                return (
                  <Question
                    isNationalOnly
                    key={questionId}
                    guesses={{ nationalAverages }}
                    question={question.onlyNational[questionId]}
                    selectedMunicipality={selectedMunicipality}
                    unit={question.onlyNational[questionId].meta.unit}
                    min={question.onlyNational[questionId].meta.min}
                    max={question.onlyNational[questionId].meta.max}
                    tenant={tenant}
                  />
                )
              })}
            </QuestionsContainer>
          </firebaseContext.Provider>
        </unityPropsContext.Provider>
        {/* <Overview selectedMunicipality={selectedMunicipality}></Overview> */}
      </MainSection>
    </AppContainer>
  )
}
const Title = styled.h2`
  //media query for mobile
  padding: 0 3rem;
  font-size: 1.9em;
  text-decoration: underline;
  @media screen and (min-width: 600px) {
    font-size: 2.4em;
  }
`
const MunicipalityQuestionsContainer = styled.div`
  /* background-color: var(--beige-bright-3); */
  width: 100%;
  margin-top: 4em;
`
const MunicipalityInfoBox = styled.div`
  background-color: var(--info-box-background);
  font-size: 1.8em;
  padding: 1.8em;
  line-height: 1.4em;
  color: var(--text-color);
`
const AppContainer = styled(TamediaStyles)<{ tenant?: string }>`
  display: flex;
  justify-content: center;
  background-color: var(--site-background);
  margin-left: auto;
  margin-right: auto;
  font-family: var(--font-sans-serif);
  color: var(--text-color);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  counter-reset: question 0;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    padding: 1em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    padding: 0em;
  }
`
const SelectedMunicipalityTitle = styled.div`
  font-size: 1.6em;
  margin: 1em 0;
`
const SearchContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  margin-bottom: 4em;
  margin-top: 2em;

  .municipality-search,
  .ui.label,
  #search {
    font-size: 18px;
  }
  .results {
    grid-template-columns: repeat(auto-fill, minmax(23.4rem, 1fr));
  }
  .result {
    color: var(--text-color) !important;
  }
  .municipality-search {
    width: 100%;

    @media screen and (min-width: 600px) {
      max-width: 20em;
    }

    .input {
      width: 100%;
    }
  }
`
const QuestionsContainer = styled.div<{ isActive: boolean }>`
  opacity: ${(props) => (props.isActive ? '1' : 0.1)};
`
const MainSection = styled.section`
  width: 100%;
`
export default MainComponent
